import { ApolloClient } from '@apollo/client'
import pThrottle from 'p-throttle'

export function avoidRateLimit(delay = 1000) {
  if (!process.env.IS_BUILD) {
    return
  }

  return new Promise((resolve) => {
    setTimeout(resolve, delay)
  })
}

// Set the limit of # of calls per interval in ms (5 per second)
const throttle = pThrottle({ limit: 2, interval: 1000 })
export const throttledFetch = throttle(
  async (client: ApolloClient, args: ApolloClient.QueryOptions) =>
    await client.query(args)
)
